
<div class="country-code">
  <div class="modal country-code-modal">
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-card">
      <section class="modal-card-body">
        <p class="title">
          {{ $t("language.select-country-code") }}
        </p>
        <div style="margin-bottom: 12px">
          <input
            class="input is-fullwidth is-medium"
            placeholder="Search country or code"
            v-model="searchText"
          />
        </div>

        <!-- <input v-model="phoneNumber" @keyup="messagingApp = null" type="number" /> -->
        <!-- <div style="height: 1200px; overflow: scroll"> -->
        <div style="max-height: calc(100% - 100px); overflow: scroll">
          <table
            v-if="!searchText"
            class="table is-fullwidth is-hoverable"
            style="margin-bottom: 12px"
          >
            <tbody style="border-bottom: 2px; border-radius: 8px">
              <tr
                v-for="country in popularCountries"
                :key="country.code"
                :value="country.code"
                @click="selectCountry(country)"
                :class="{ selected: country.prefix == selectedPrefix }"
                style="border-radius: 8px"
              >
                <th>{{ country.prefix }}</th>
                <!-- <th>{{ country.code }}</th> -->
                <td class="name">{{ country.name }}</td>
              </tr>
            </tbody>
          </table>
          <table class="table is-fullwidth is-hoverable">
            <tbody>
              <tr
                v-for="country in filteredCountries"
                :key="country.code"
                :value="country.code"
                @click="selectCountry(country)"
                :class="{ selected: country.prefix == selectedPrefix }"
              >
                <th>{{ country.prefix }}</th>
                <!-- <th>{{ country.code }}</th> -->
                <td class="name">{{ country.name }}</td>
              </tr>
              <tr>
                <th style="display: flex">
                  <span style="position: relative; top: 3px">+</span>
                  <input
                    class="input"
                    v-model="other"
                    type="number"
                    maxlength="4"
                  />
                </th>
                <td class="name" @click="otherCountryCode">
                  {{ $t("other") }}&nbsp;
                  <a
                    v-if="other"
                    class="button is-primary is-small is-rounded"
                  >
                    <i class="fa fa-chevron-right fa-lg" />
                  </a>
                  <p v-if="error && !other" class="has-text-danger error">
                    {{ error }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="closeModal"
    ></button>
  </div>
</div>
